import script from "./HelpButton.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpButton.vue?vue&type=script&setup=true&lang=js"

import "./HelpButton.vue?vue&type=style&index=0&id=2a657450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a657450"]])

export default __exports__